module.exports = __webpack_public_path__ + "img/peace.0fa6beef.png";